import api from './api.config'
import app from './app.config'
import links from './links.config'

export default {
    app,
    api,
    links,
}
